
import type { QueryRankingPinnedElementDTO } from '@empathyco/playboard-core-domain'
import type { PropType } from 'vue'
import type { ToolsMessages } from '../../models'
import { computed, defineComponent } from 'vue'
import RankingElementsList from '../configurations/ranking-elements-list.component.vue'

export default defineComponent({
  name: 'PinnedProductsList',
  components: {
    RankingElementsList,
  },
  props: {
    rankingElements: {
      type: Array as PropType<Array<QueryRankingPinnedElementDTO>>,
      required: true,
    },
    messages: {
      type: Object as PropType<ToolsMessages['configurations']>,
      required: true,
    },
    readOnly: Boolean,
  },
  setup(props) {
    const sortedRankingElements = computed((): QueryRankingPinnedElementDTO[] => {
      return props.rankingElements.sort((config1, config2) => config1.position - config2.position)
    })

    return {
      sortedRankingElements,
    }
  },
})
